import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import TextForm from "../types/TextForm";

export const OrderStateForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderState}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <TextForm
        node={node}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
